import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'event_list_table.cells.event_info';

export const useEventInfoCellTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => {
  return useTranslation('entities', { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    detection: 'Обнаружение',
    handler: 'Сценарий',
    lists: 'Список',
    lists_tooltip: 'Список, по которому произошло совпадение. Чтобы увидеть все списки, в которых состоит карточка на данный момент, перейдите в неё.',
    location: 'Место',
    match: 'Совпадение',
    source: 'Источник',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    detection: 'Detection',
    handler: 'Handler',
    lists: 'List',
    lists_tooltip: 'The list that triggered the match. To see all lists that currently contain the card, open the card.',
    location: 'Location',
    match: 'Match',
    source: 'Source',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    detection: 'Detección',
    handler: 'Escenario',
    lists: 'Lista',
    lists_tooltip: 'La lista que produjo la coincidencia. Para ver todas las listas que contienen la tarjeta actualmente, abra la tarjeta.',
    location: 'Ubicación',
    match: 'Coincidencia',
    source: 'Fuente',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    detection: 'Detecção',
    handler: 'Cenário',
    lists: 'Lista',
    lists_tooltip: 'A lista que gerou a correspondência. Para ver todas as listas que contêm o cartão no momento, abra o cartão.',
    location: 'Localização',
    match: 'Correspondência',
    source: 'Fonte',
  },
}) as Record<string, unknown>;
